import { useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { getCampaigns, getAccountReport } from '../../mailTemplate/src/services/B2BServices'
import { useToast } from './useToast'

export const useCampaigns = (b2bAccountId) => {
  const { t } = useTranslation()

  const { showError } = useToast()

  const [isLoading, setIsLoading] = useState(false)

  const [campaigns, setCampaigns] = useState([])
  const [campaignReports, setCampaignReports] = useState(null)

  const fetchCampaigns = useCallback(async () => {
    if (!b2bAccountId) return

    try {
      setIsLoading(true)
      const campaignRes = await getCampaigns({ b2bAccountId })
      setCampaigns(campaignRes.data)

      const reportRes = await getAccountReport(b2bAccountId)
      setCampaignReports(reportRes.data)

      return campaignRes.data
    } catch (err) {
      showError(err || t('mailTemplate.campaigns.fetchErr'))
      throw err
    } finally {
      setIsLoading(false)
    }
  }, [b2bAccountId, showError, t])

  return {
    campaigns,
    campaignReports,
    setCampaignReports,
    fetchCampaigns,
    isLoading
  }
}
